import { URefResult } from '@block-explorer/entities';
import {
  stringifyCLTypeType,
  stringifyCLTypeValue,
} from '../../../utils/cltype';
import { useGetAccountBalance } from '../../../hooks';

export type URefData = {
  type: string | null;
  value: any;
};

export const useGetURefDetailsFromRawData = (
  params: {
    CLValueData: URefResult | undefined | null;
    hash: string;
  } | null
): URefData | null => {
  const { data: balance, loading: balanceLoading } = useGetAccountBalance({
    mainPurseUref: params?.hash || null,
  });

  if (!params || !params?.CLValueData) {
    return null;
  }

  const {
    CLValueData: { cl_type, parsed },
  } = params;

  return {
    type: stringifyCLTypeType(cl_type),
    value: stringifyCLTypeValue({
      type: cl_type,
      value: parsed,
      balance: balance && !balanceLoading ? balance : null,
    }),
  };
};
